// Student Editor - PartCPage4 (Pixel-perfect redesign - editable learner reflection)
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useActivityContext } from '../index';
import { API_CONFIG } from '../../../../../config/api';

const PartCPage4 = () => {
  const { activity } = useActivityContext();
  const [formData, setFormData] = useState({
    awareness: { item_1: false, item_2: false, item_3: false },
    sensitivity: { item_1: false, item_2: false, item_3: false },
    creativity: { item_1: false, item_2: false, item_3: false },
    problems_faced: '',
    how_solved: ''
  });
  const [saveMessage, setSaveMessage] = useState('');

  useEffect(() => {
    if (activity?.my_response_part_c?.page_4) {
      setFormData(activity.my_response_part_c.page_4);
    }
  }, [activity]);

  const saveChanges = async (data) => {
    try {
      const token = localStorage.getItem('accessToken');
      const apiUrl = API_CONFIG.BASE_URL;

      await axios.put(
        `${apiUrl}/secondary/user/domain-activities/${activity.activity_id}/part-c/page/4/student-fields`,
        data,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setSaveMessage('Saved ✓');
      setTimeout(() => setSaveMessage(''), 2000);
    } catch (error) {
      console.error('Error:', error);
      setSaveMessage('Error');
    }
  };

  const handleCategoryChange = (category, field, value) => {
    const newFormData = { ...formData, [category]: { ...formData[category], [field]: value } };
    setFormData(newFormData);
    saveChanges(newFormData);
  };

  const handleFieldChange = (field, value) => {
    const newFormData = { ...formData, [field]: value };
    setFormData(newFormData);
    saveChanges(newFormData);
  };

  const calculateTotal = (category) => {
    const cat = formData[category];
    let total = 0;
    if (cat.item_1) total++;
    if (cat.item_2) total++;
    if (cat.item_3) total++;
    return total;
  };

  const renderCategory = (categoryName, title, items) => {
    const category = formData[categoryName];

    return (
      <div style={{ marginBottom: '12px' }}>
        <div style={{
          backgroundColor: '#4A90A4',
          color: 'white',
          padding: '6px 12px',
          fontWeight: 'bold',
          fontSize: '14px',
          marginBottom: '0'
        }}>
          {title}
        </div>
        <div style={{
          fontSize: '14px',
          padding: '10px 12px',
          backgroundColor: '#B3D9E8',
          minHeight: '80px'
        }}>
          {items.map((item, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '5px' }}>
              <input
                type="checkbox"
                checked={category[`item_${index + 1}`]}
                onChange={(e) => handleCategoryChange(categoryName, `item_${index + 1}`, e.target.checked)}
                style={{
                  width: '16px',
                  height: '16px',
                  marginRight: '8px',
                  marginTop: '1px',
                  cursor: 'pointer',
                  flexShrink: 0
                }}
              />
              <span style={{ lineHeight: '1.4' }}>{item}</span>
            </div>
          ))}

          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            marginTop: '12px',
            paddingTop: '8px'
          }}>
            <span style={{ marginRight: '10px', fontWeight: 'bold', fontSize: '14px' }}>Total number of (✓):</span>
            <div style={{
              width: '35px',
              height: '35px',
              border: '3px solid #4A90A4',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '14px',
              backgroundColor: 'white'
            }}>
              {calculateTotal(categoryName)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div style={{
        width: '100%',
        maxWidth: '1400px',
        minHeight: '80vh',
        margin: '0 auto',
        padding: '40px',
        backgroundColor: 'white',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        position: 'relative',
        fontFamily: "'Poppins', Arial, sans-serif"
      }}>
        {saveMessage && (
          <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            backgroundColor: saveMessage.includes('Error') ? '#f44336' : '#4caf50',
            color: 'white',
            padding: '8px 16px',
            borderRadius: '4px',
            zIndex: 1000
          }}>
            {saveMessage}
          </div>
        )}

        

        <div style={{
          fontSize: '14px',
          fontWeight: 'bold',
          marginBottom: '10px',
          textAlign: 'center',
          backgroundColor: '#F4824C',
          color: 'white',
          padding: '8px'
        }}>
          Stage 1
        </div>

        <div style={{
          fontSize: '15px',
          fontWeight: 'bold',
          marginBottom: '12px',
          backgroundColor: '#4A90A4',
          color: 'white',
          padding: '6px 12px',
          display: 'inline-block'
        }}>
          Learner Reflection
        </div>

        <div style={{
          fontSize: '14px',
          marginBottom: '15px',
          padding: '0',
          fontWeight: 'bold',
          lineHeight: '1.5'
        }}>
          Tick (✓) all statements that apply.
        </div>

        {renderCategory('awareness', 'Awareness', [
          'I understood the purpose of the research project.',
          'I was able to draft a questionnaire that fits the purpose of the research project.',
          'I was able to find out things I did not know that would help me complete the research project.'
        ])}

        {renderCategory('sensitivity', 'Sensitivity', [
          'I understood the larger social purpose of the research project.',
          'I used my knowledge of social relationships to choose the respondents.',
          'I considered people\'s possible emotional reactions and needs when drafting the questionnaire.'
        ])}

        {renderCategory('creativity', 'Creativity', [
          'I was able to consider different possible groups of respondents to use for my data.',
          'I considered various ways to motivate the respondents to provide data.',
          'I was able to consider different methods of collecting data.'
        ])}

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px', position: 'relative' }}>
          <div>
            <div style={{
              backgroundColor: '#4A90A4',
              color: 'white',
              padding: '8px 12px',
              fontWeight: 'bold',
              fontSize: '14px',
              marginBottom: '0',
              textAlign: 'center',
              lineHeight: '1.3'
            }}>
              What problems did I face in Stage 1?
            </div>
            <textarea
              value={formData.problems_faced}
              onChange={(e) => handleFieldChange('problems_faced', e.target.value)}
              placeholder="Describe the problems you faced..."
              style={{
                width: '100%',
                padding: '10px 12px',
                fontSize: '14px',
                minHeight: '120px',
                backgroundColor: '#B3D9E8',
                border: 'none',
                lineHeight: '1.4',
                fontFamily: "'Poppins', Arial, sans-serif",
                resize: 'vertical',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div>
            <div style={{
              backgroundColor: '#4A90A4',
              color: 'white',
              padding: '8px 12px',
              fontWeight: 'bold',
              fontSize: '14px',
              marginBottom: '0',
              textAlign: 'center',
              lineHeight: '1.3'
            }}>
              How did I solve them? What help do I still need?
            </div>
            <textarea
              value={formData.how_solved}
              onChange={(e) => handleFieldChange('how_solved', e.target.value)}
              placeholder="Describe how you solved them and what help you need..."
              style={{
                width: '100%',
                padding: '10px 12px',
                fontSize: '14px',
                minHeight: '120px',
                backgroundColor: '#B3D9E8',
                border: 'none',
                lineHeight: '1.4',
                fontFamily: "'Poppins', Arial, sans-serif",
                resize: 'vertical',
                boxSizing: 'border-box'
              }}
            />
          </div>

          <div style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '28px',
            color: '#4A90A4',
            fontWeight: 'bold',
            zIndex: 1,
            backgroundColor: 'white',
            padding: '0 5px'
          }}>
            ⇒
          </div>
        </div>

        
        
      </div>

  );
};

export default PartCPage4;
